import React, { FC } from 'react';

import { Flex } from '@chakra-ui/react';

import { Routes } from 'react-router-dom';

import ROUTES, { routesSettings } from 'constants/routes';

import QrRedirect from './QrRedirect';
import NotFound from 'routes/portal/NotFound';

import getRoute from 'components/core/RouteWithSubRoutes';

const routeConfig = Object.freeze({
  // Dedicated QR host: qr.rworldreuse.com/:code
  [ROUTES.QR_REDIRECT_HOST]: {
    element: <QrRedirect />,
    path: routesSettings.QR_REDIRECT_HOST.path,
  },
  // Same-origin / local testing: /qr/:code
  [ROUTES.QR_REDIRECT]: {
    element: <QrRedirect />,
    path: routesSettings.QR_REDIRECT.path,
  },
  [ROUTES.PORTAL_NOT_FOUND]: {
    element: <NotFound />,
    path: routesSettings.PORTAL_NOT_FOUND.path,
  },
});

const QrRoutes: FC = () => {
  return (
    <Flex flex={1}>
      <Flex bg="#fff" flexGrow={1} flexBasis={0} overflow="auto">
        <Routes>
          {Object.entries(routeConfig).map(([, val]) => getRoute(val))}
        </Routes>
      </Flex>
    </Flex>
  );
};

export default QrRoutes;
